import { intl } from './intl';

export const { t: dialogsT, Message: DialogsMessage } = intl.createMessages({
    deleteVideoTitle: {
        ru: 'Удалить видео?',
        en: 'Delete video?',
    },
    deleteVideoWarning: {
        ru: 'Восстановить видео "{title}" будет невозможно',
        en: 'It will be impossible to restore video "{title}"',
    },
    shareVideoTitle: {
        ru: 'Код вставки',
        en: 'Embed code',
    },
    editVideoTitle: {
        ru: 'Редактирование файла',
        en: 'Edit file',
    },
});
